import { globalConst } from '..';

import { isBrowser } from './is-browser';

export type YandexGoalKeyType = keyof typeof globalConst.yandexGoalKeys;

export const onTrackYandexGoal = (goalName: YandexGoalKeyType) => {
  if (isBrowser() && typeof window?.ym !== 'undefined') {
    window.ym(88696245, 'reachGoal', goalName);
  } else if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.log(`YM goal [${goalName}] not sent (no window.ym)`);
  }
};
